module.exports = __webpack_public_path__ + "static/media/logo-dark-1_a.defdfd0d.svg";